export default __webpack_public_path__ + "static/media/gallery_02.8242b56f.jpg";